import type { InjectionKey } from 'vue';
import type { InjectionValue } from '@tools/types';

export const isDisabledInjectionKey = Symbol('isDisabled') as InjectionKey<InjectionValue<boolean>>;
export const isReadonlyInjectionKey = Symbol('isReadonly') as InjectionKey<InjectionValue<boolean>>;
export const hideRequiredAsteriskInjectionKey = Symbol('hideRequiredAsterisk') as InjectionKey<
  InjectionValue<boolean>
>;
